module.exports = __webpack_public_path__ + "static/img/icon_menu_32@2x.4c5236f5.png";